// extracted by mini-css-extract-plugin
module.exports = {"cont":"ua_cont__INmsp","form":"ua_form__5COe9","rows":"ua_rows__BAGcF","divider":"ua_divider__znRGj","panel":"ua_panel__0jta6"};